import * as z from "zod/v4";

export const getRollupRebuildProgress = {
  name: "getRollupRebuildProgress" as const,
  input: z.object({}),
  output: z.object({
    found: z.boolean(),
    running: z.boolean(),
    progress: z
      .object({
        totalAccounts: z.number(),
        succeededAccounts: z.number(),
        currentAccountId: z.string().nullable(),
        failedAccountIds: z.array(z.string()),
        status: z.enum(["running", "completed", "failed"]),
      })
      .nullable(),
  }),
};
